export const balanceConstants = {
    heading: `# Check your card balance`,
    subHeading: `#### Please fill in your **Claim Activation Code** below to check your card balance.`,
    balanceText: `Please note that your claim activation code is located at the back of the card and be sure to not include any spaces.`,
    balanceButtonText: `Check Balance`,
    balanceTableHeading: `## Balance`,
    defaultValue: {
        activationCode: '',
    },
}